module.exports = __webpack_public_path__ + "static/img/Human-performance-analysis-icon-2.b62c17d9.svg";